module.exports = __webpack_public_path__ + "img/mcdonalds_small.f2b7ed81.png";